import React from "react";
import ContentWrapper from "@/presentation/components/content-wrapper";
import ContentFormLayoutWrapper from "@/presentation/components/content-wrapper/content-form-layout-wrapper";
import { Header } from "@cloudscape-design/components-themed/components";
import SettingsActionMetadataOverridesEdit from "./settings-action-metadata-overrides-edit";
const SettingsActionMetadataOverridesFormWrapper = () => {
    return React.createElement(ContentWrapper, { testid: "settings-action-metadata-overrides-edit-page" },
        React.createElement(ContentFormLayoutWrapper, { header: React.createElement(Header, { variant: "h1" }, "Edit Action Metadata") },
            React.createElement(SettingsActionMetadataOverridesEdit, null)));
};
export default SettingsActionMetadataOverridesFormWrapper;
